import { ViewChangelog } from '@xeetr/types/models'

import ApiService from './common/API.service'

export class ChangelogService extends ApiService {
  getChangelog = async (bookingId: string): Promise<ViewChangelog[]> => {
    const { data } = await this.get<ViewChangelog[]>(this.buildCommonUrl('changelog'), {
      params: { id: bookingId },
    })
    return data
  }
}
